"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.EventType = exports.DelayUnit = exports.HttpMethod = exports.WorkflowBlockType = exports.ActionType = exports.TriggerType = exports.WorkflowTrigger = exports.WorkflowBlock = exports.EntityTriggerConfig = exports.ActionBlockConfig = exports.DelayBlockConfig = exports.FilterBlockConfig = exports.APIBlockConfig = exports.WorkflowDocument = void 0;
var workflow_document_1 = require("./workflow-document");
__createBinding(exports, workflow_document_1, "WorkflowDocument");
__createBinding(exports, workflow_document_1, "APIBlockConfig");
__createBinding(exports, workflow_document_1, "FilterBlockConfig");
__createBinding(exports, workflow_document_1, "DelayBlockConfig");
__createBinding(exports, workflow_document_1, "ActionBlockConfig");
__createBinding(exports, workflow_document_1, "EntityTriggerConfig");
__createBinding(exports, workflow_document_1, "WorkflowBlock");
__createBinding(exports, workflow_document_1, "WorkflowTrigger");
var workflow_enums_1 = require("./workflow-enums");
__createBinding(exports, workflow_enums_1, "TriggerType");
__createBinding(exports, workflow_enums_1, "ActionType");
__createBinding(exports, workflow_enums_1, "WorkflowBlockType");
__createBinding(exports, workflow_enums_1, "HttpMethod");
__createBinding(exports, workflow_enums_1, "DelayUnit");
__createBinding(exports, workflow_enums_1, "EventType");
